import {
  STEPS,
  PLATE_POOLING,
  PLATE_POOLING_OPTIONS,
  REMAINDER_CHECKED,
  REMAINDER_PLATE_TYPE,
  REMAINDER_TREATMENT,
  REMAINDER_VOLUME,
  POOLED_PLATES,
  PLATES_FOR_POOLING,
  NORMALIZATION,
  ALIQUOTS_CHECKED,
  ALIQUOTS_NUMBER,
  ALIQUOTS_VOLUME,
  CONCENTRATION,
  CONCENTRATION_UNIT,
  NORMALIZATION_CONCENTRATION_UM_DEFAULT_VALUE,
  VOLUME,
  VOLUME_UNIT,
  NORMALIZATION_VOLUME_DEFAULT_VALUE,
  UNITS,
  ALIQUOTS_VOLUME_DEFAULT_VALUE,
  ALIQUOTS_NUMBER_DEFAULT_VALUE,
  REMAINDER_VOLUME_DEFAULT_VALUE,
  POOLED_PLATE_VOLUME,
  POOLED_PLATE_VOLUME_MIN_VALUE,
  POOLED_PLATE_NAME,
  POOLED_PLATE_NAME_VALUE,
  PLATE_SIZE_FIELD,
  WELL_FIELD,
  SCALE_FIELD,
  PURIFICATION_FIELD,
  BUFFER_FIELD,
  SHIPPING_FORMAT_FIELD,
  BUFFER,
  SHIPPING_FORMAT,
  REMAINDER_VALUES,
  NORMALIZATION_OPTIONS,
  PLATE_SIZES,
  WELL_VOLUME_DEFAULT_VALUE_FOR_PLATE_SIZE_96,
  WELL_VOLUME_DEFAULT_VALUE_FOR_PLATE_SIZE_384,
  QUALITY_TESTING_FIELD,
  QUALITY_TESTING_DEFAULT_VALUE,
  COUNTRY_CODE_JAPAN,
  DESIGN_ID,
} from 'src/constants/forms';
import { toDecimalValue, getCountryCode } from 'src/utils';

const getDefaultFormStatePlateSizeDetails = (initialValues = {}) => ({
  [PLATE_SIZE_FIELD]: {
    value: initialValues[PLATE_SIZE_FIELD] || '',
    isValid: true,
  },
  [WELL_FIELD]: {
    value: initialValues[WELL_FIELD] || (initialValues[PLATE_SIZE_FIELD] === PLATE_SIZES.SIZE_96 ?
      WELL_VOLUME_DEFAULT_VALUE_FOR_PLATE_SIZE_96 :
      WELL_VOLUME_DEFAULT_VALUE_FOR_PLATE_SIZE_384),
    isValid: true,
  },
  [SCALE_FIELD]: {
    value: initialValues[SCALE_FIELD] || '',
    isValid: true,
  },
  [PURIFICATION_FIELD]: {
    value: initialValues[PURIFICATION_FIELD] || '',
    isValid: true,
  },
  [BUFFER_FIELD]: {
    value: initialValues[BUFFER_FIELD] || BUFFER.TE,
    isValid: true,
  },
  [QUALITY_TESTING_FIELD]: {
    value: initialValues[QUALITY_TESTING_FIELD] || QUALITY_TESTING_DEFAULT_VALUE,
    isValid: getCountryCode() !== COUNTRY_CODE_JAPAN,
  },
  [SHIPPING_FORMAT_FIELD]: {
    value: initialValues[SHIPPING_FORMAT_FIELD] || SHIPPING_FORMAT.DRIED,
    isValid: true,
  },
  [DESIGN_ID]: {
    value: initialValues[DESIGN_ID],
    isValid: true,
  },
});

const getDefaultFormStateNormalizationAliquots = () => ({
  [NORMALIZATION]: {
    value: NORMALIZATION_OPTIONS.NONE,
    isValid: true,
  },
  [VOLUME]: {
    value: NORMALIZATION_VOLUME_DEFAULT_VALUE,
    isValid: true,
  },
  [VOLUME_UNIT]: {
    value: UNITS.volume[0].value,
    isValid: true,
  },
  [CONCENTRATION]: {
    value: toDecimalValue(NORMALIZATION_CONCENTRATION_UM_DEFAULT_VALUE),
    isValid: true,
  },
  [CONCENTRATION_UNIT]: {
    value: UNITS.concentration[0].value,
    isValid: true,
  },
  [ALIQUOTS_CHECKED]: {
    value: false,
    isValid: true,
  },
  [ALIQUOTS_NUMBER]: {
    value: ALIQUOTS_NUMBER_DEFAULT_VALUE,
    isValid: true,
  },
  [ALIQUOTS_VOLUME]: {
    value: ALIQUOTS_VOLUME_DEFAULT_VALUE,
    isValid: true,
  },
});

const getDefaultFormStatePlatePooling = () => ({
  [PLATE_POOLING]: {
    value: PLATE_POOLING_OPTIONS.NONE,
    isValid: true,
  },
  [POOLED_PLATE_VOLUME]: {
    value: POOLED_PLATE_VOLUME_MIN_VALUE,
    isValid: true,
  },
  [POOLED_PLATES]: {
    value: [],
    isValid: true,
  },
  [POOLED_PLATE_NAME]: {
    value: POOLED_PLATE_NAME_VALUE,
    isValid: true,
  },
  [PLATES_FOR_POOLING]: {
    value: [],
    isValid: true,
  },
});

const getDefaultRemaindersState = () => ({
  [REMAINDER_CHECKED]: {
    value: false,
    isValid: true,
  },
  [REMAINDER_PLATE_TYPE]: {
    value: REMAINDER_VALUES.UL_1200,
    isValid: true,
  },
  [REMAINDER_TREATMENT]: {
    value: REMAINDER_VALUES.DRY,
    isValid: true,
  },
  [REMAINDER_VOLUME]: {
    value: toDecimalValue(REMAINDER_VOLUME_DEFAULT_VALUE),
    isValid: true,
  },
});

export default class DnaOligoState {
  static getDefaultFormState(step, data = {}) {
    switch (step) {
      case STEPS.PLATE_SIZE_DETAILS:
        return getDefaultFormStatePlateSizeDetails(data);
      case STEPS.NORMALIZATION_ALIQUOTS:
        return getDefaultFormStateNormalizationAliquots(data);
      case STEPS.PLATE_POOLING:
        return getDefaultFormStatePlatePooling(data);
      default:
        return {};
    }
  }

  static getDefaultRemaindersState = getDefaultRemaindersState;
}
